"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
const theme_1 = __importDefault(require("../../styles/theme"));
const utils_1 = require("../../lib/utils");
const TableRow = (_a) => {
    var { background = 'none', children, onClick = utils_1.noop, style } = _a, commonProps = __rest(_a, ["background", "children", "onClick", "style"]);
    return (react_1.default.createElement(TableRow_1.default, Object.assign({}, commonProps, { onClick: onClick, style: Object.assign({ borderBottom: `1px ${theme_1.default.colors.borderDefault} solid`, cursor: `${onClick !== utils_1.noop ? 'pointer' : 'auto'}`, background: `${background}` }, style) }), children));
};
exports.default = TableRow;
